export const recoveryErrorKey = (error) => {
    if (error?.code === "DELETION_NO_LONGER_RECOVERABLE") {
        return "accountDeletionPublic.recovery.errors.noLongerRecoverable";
    }
    if (error?.code === "RATE_LIMITED") {
        return "accountDeletionPublic.recovery.errors.rateLimited";
    }
    return "accountDeletionPublic.recovery.errors.generic";
};
